"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeader = void 0;
var components_1 = require("../../components");
var react_1 = __importDefault(require("react"));
var config_provider_1 = require("antd/lib/config-provider");
var i18n_1 = __importDefault(require("./i18n"));
var antd_1 = require("antd");
function TableHeader(props) {
    var _a, _b;
    var rowDescriptor = (_a = props.rowDescriptor) !== null && _a !== void 0 ? _a : "row";
    var rowDescriptorPluralized = (_b = props.rowDescriptorPluralized) !== null && _b !== void 0 ? _b : "rows";
    return (react_1.default.createElement(config_provider_1.ConfigConsumer, null, function (_a) {
        var _b;
        var locale = _a.locale;
        var i18n = getLocalizedStrings(locale);
        return (react_1.default.createElement("div", { className: "table-header" },
            react_1.default.createElement("div", { className: "table-header-row-selection" }, props.numberOfSelectableRows > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                props.numberOfRowsSelected > 0 ? (react_1.default.createElement(components_1.Typography.Text, null, i18n.rowsSelected(props.numberOfRowsSelected, props.numberOfRows, rowDescriptorPluralized))) : (react_1.default.createElement(components_1.Typography.Text, null,
                    props.numberOfRows,
                    " ",
                    props.numberOfRows > 1 ? rowDescriptorPluralized : rowDescriptor)),
                props.numberOfRowsSelected == props.numberOfSelectableRows && (react_1.default.createElement(components_1.Button, { type: "link", onClick: function () { return props.onDeselectAll(); } }, i18n.deselectAll)),
                props.numberOfRowsSelected < props.numberOfSelectableRows && (react_1.default.createElement(components_1.Button, { type: "link", onClick: function () { return props.onSelectAll(); } }, i18n.selectAll)))) : (react_1.default.createElement(react_1.default.Fragment, null, props.numberOfRows > 0 && (react_1.default.createElement(components_1.Typography.Text, null,
                props.numberOfRows,
                " ",
                props.numberOfRows > 1 ? rowDescriptorPluralized : rowDescriptor))))),
            react_1.default.createElement(antd_1.Space, null, (_b = props.actions) === null || _b === void 0 ? void 0 : _b.map(function (action, index) { return (react_1.default.createElement(react_1.default.Fragment, { key: index }, action)); }))));
    }));
}
exports.TableHeader = TableHeader;
var getLocalizedStrings = function (locale) {
    var localeCode = locale && locale.locale ? locale.locale : "en";
    return i18n_1.default[localeCode] ? i18n_1.default[localeCode] : i18n_1.default["en"];
};
//# sourceMappingURL=TableHeader.js.map